import MainLayout from "@/components/layout/admin/MainLayout.vue";
import TeacherLeaveForm from "@/components/common/teacher_leave/TeacherLeaveForm.vue";
import Select2Multiple from "v-select2-multiple-component";
import Loading from "vue-loading-overlay";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";

export default {
  name: "leaveEdit",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
    TeacherLeaveForm,
  },

  data() {
    return {
      leaveData: {},
      submitted: false,
      disabled: false,
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      teacherArr: [],
      images: [],
      existingImages: [],
      formValidations: null,
    };
  },

  methods: {
    setValidations(validations) {
      this.formValidations = validations;
    },

    getDetail() {
      axios.get(`teacher/leave/detail/${this.$route.params.id}`)
        .then(res => {
          this.leaveData = res.data;
          if (res.data.leave_images) {
            this.existingImages = res.data.leave_images;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Leave Detail API Error", error);
        })
    },

    update() {
      this.isLoading = true;
      this.submitted = true;
      this.disabled = true;

      this.formValidations.$touch(); 
      if (this.formValidations.$invalid) {
        this.isLoading = false;
        this.disabled = false;
        return;
      }
      this.leaveData.leave_images = this.existingImages;
      this.leaveData.new_images = this.images;
      this.leaveData.login_id = this.$store.state.user.id;
      axios.post(`teacher/leave/update/${this.$route.params.id}`, this.leaveData)
        .then(res => {
          if(res.data.success == true) {
            this.$notification.success("Leave Form Updated Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "teacherLeaveList"
            });
          }
        })
        .catch(error => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            if (error.response.status == 422) {
              this.$notification.error(error.response.data.message, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
        })
    }
  },

  mounted() {
    this.isLoading = true;
    this.getDetail();
  },
};
